import { Bootstrapper } from "../Bootstrapper";

export class ServiceWorkerBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): void {
        if(!navigator.serviceWorker) {
            console.debug("Service worker is not supported in this environment");

            return;
        }

        window.addEventListener("load", () => {
            void navigator.serviceWorker.register("/serviceworker.js");
        });
    }
}
